import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import './Subscription.css';

interface CancellationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    subscription: {
        paymentType?: 'one-time' | 'recurring' | 'manual';
        subscriptionEndDate?: string | null;
    } | null;
}

export const CancellationModal: React.FC<CancellationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    subscription,
}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleConfirm = async () => {
        setLoading(true);
        setError(null);
        try {
            await onConfirm();
            onClose();
        } catch (err: any) {
            setError(err.message || 'Erro ao cancelar assinatura');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString?: string | null) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('pt-BR');
    };

    const isRecurring = subscription?.paymentType === 'recurring';

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Cancelar Assinatura"
            footer={
                <>
                    <Button variant="secondary" onClick={onClose} disabled={loading}>
                        Voltar
                    </Button>
                    <Button onClick={handleConfirm} disabled={loading} variant="secondary">
                        {loading ? 'Cancelando...' : 'Confirmar Cancelamento'}
                    </Button>
                </>
            }
        >
            <div className="ns-cancellation-modal-content">
                <div className="ns-cancellation-warning">
                    <h3>⚠️ Tem certeza que deseja cancelar?</h3>
                </div>

                <div className="ns-cancellation-info">
                    <h4>O que acontece ao cancelar:</h4>
                    <ul>
                        {isRecurring ? (
                            <>
                                <li>✓ Sua assinatura recorrente será cancelada no Mercado Pago</li>
                                <li>✓ Não haverá mais cobranças automáticas</li>
                                <li>
                                    ✓ Você manterá acesso completo até{' '}
                                    <strong>{formatDate(subscription?.subscriptionEndDate)}</strong>
                                </li>
                                <li>✓ Após essa data, sua conta será desativada</li>
                            </>
                        ) : (
                            <>
                                <li>✓ Sua assinatura será marcada como cancelada</li>
                                <li>
                                    ✓ Você manterá acesso completo até{' '}
                                    <strong>{formatDate(subscription?.subscriptionEndDate)}</strong>
                                </li>
                                <li>✓ Após essa data, será necessário renovar para continuar usando</li>
                            </>
                        )}
                    </ul>
                </div>

                <div className="ns-cancellation-note">
                    <p>
                        <strong>Importante:</strong> Você pode reativar sua assinatura a qualquer momento
                        antes do término da validade atual.
                    </p>
                </div>

                {error && (
                    <div className="ns-payment-error">
                        <p>{error}</p>
                    </div>
                )}
            </div>
        </Modal>
    );
};
